import { render, staticRenderFns } from "./RegistrationGroup.vue?vue&type=template&id=558ec911&"
import script from "./RegistrationGroup.vue?vue&type=script&lang=js&"
export * from "./RegistrationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports